export default {
  title: 'DISPATCH SETTINGS',
  items: {
    findNearbyDriverLimit: {
      label: 'Find Nearby driver time limit',
      type: 'integer',
      unit: 'minutes'
    },
    AssignsRequireShifts: {
      label: 'Restriction based availability',
      type: 'boolean'
    },
    // DispatchShowDriverPayment: {
    //   label: 'Show Driver Payment Column',
    //   type: 'boolean'
    // }
  }
}
  


// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/dispatch-settings.js